




























































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import { mixins } from "vue-class-component";
import ImportPage from "@/lib/import-page";

@Component({
  components: {},
})
export default class ImportProduct extends mixins(AbpBase, ImportPage) {
  importPageName = "Product";
  namespace = "productImport";

  //filters
  current: number = 0;
  productFileId: number = 0;
  spinShow: boolean = false;
  get countItems() {
    return this.$store.state.productImport.countItems;
  }
  get countImportedItems() {
    return this.$store.state.productImport.countImportedItems;
  }
  get list() {
    return this.$store.state.productImport.itemsImported;
  }
  get loading() {
    return this.$store.state.productImport.loading;
  }
  create() {}
  activeStep(next: boolean) {
    if (next && this.current < 1) {
      this.current++;
    }
    if (!next && this.current > 0) {
      this.current--;
    }
  }
  nextStep() {
    this.activeStep(true);
  }

  backStep() {
    this.activeStep(false);
  }
  async exportToExcel() {
    await this.$store.dispatch({
      type: "productImport/export",
      data: this.productFileId,
    });
  }
  columns = [
    {
      title: this.L("ErrorMessage"),
      width: 200,
      fixed: "left",
      slot: "errorMessage",
    },
    {
      title: this.L("SKU"),
      key: "sku",
      width: 150,
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 150,
    },
    {
      title: this.L("Unit"),
      key: "unitCode",
      width: 150,
    },
    {
      title: this.L("Category"),
      key: "categoryCode",
      width: 150,
    },
    {
      title: this.L("StorageType"),
      key: "storageType",
      width: 100,
    },
    {
      title: this.L("Type"),
      key: "type",
      width: 120,
    },
    {
      title: this.L("InventModel"),
      key: "inventModel",
      width: 100,
    },
    {
      title: this.L("ExternalCode"),
      key: "externalCode",
      width: 150,
    },
    {
      title: this.L("Length"),
      key: "length",
      width: 80,
    },
    {
      title: this.L("Width"),
      key: "width",
      width: 80,
    },
    {
      title: this.L("Height"),
      key: "height",
      width: 80,
    },
    {
      title: this.L("Weight"),
      key: "weight",
      width: 80,
    },
    {
      title: this.L("BrandName"),
      key: "brandName",
      width: 150,
    },
    {
      title: this.L("IsAccessories"),
      key: "isAccessories",
      width: 80,
    },
    {
      title: this.L("IsWarranty"),
      key: "isWarranty",
      width: 80,
    },
    {
      title: this.L("WarrantyDuration"),
      key: "warrantyDuration",
      width: 80,
    },
    {
      title: this.L("Tax"),
      key: "tax",
      width: 80,
    },
    {
      title: this.L("Note"),
      key: "note",
      width: 200,
    },
    {
      title: this.L("ExternalClientCodes"),
      key: "externalClientCodes",
      width: 150,
    },
    {
      title: this.L("IsImported"),
      width: 100,
      fixed: "right",
      align: "center",
      render: (h: any, params: any) => {
        return h("div", [
          h(
            "Icon",
            {
              props: {
                size: 36,
                type: params.row.isImported
                  ? "md-checkmark-circle"
                  : "md-close-circle",
              },
            },
            ""
          ),
        ]);
      },
    },
  ];

  async created() {
    if (!this.checkSignalConnected()) return;
    if (Util.abp.signalr && Util.abp.signalr.hubs.common.state == 1) {
      Util.abp.signalr.hubs.common.on("Import.Product", (notification) => {
        this.processNotifierImportProduct(notification);
      });
    } else {
      abp.event.on("abp.signalr.connected", () => {
        Util.abp.signalr.hubs.common.on("Import.Product", (notification) => {
          this.processNotifierImportProduct(notification);
        });
      });
    }
  }

  processNotifierImportProduct(notification: any) {
    if (notification.productFileId == this.productFileId) {
      this.$store.commit({
        type: "productImport/processNotifier",
        data: notification,
      });
    }
  }
  handleBeforeUpload(file) {
    const fileExt = file.name.split(".").pop().toLocaleLowerCase();

    if (fileExt === "xlsx" || fileExt === "xls") {
      let data = new FormData();
      data.append("file", file);
      this.spinShow = true;
      this.$store
        .dispatch("productImport/uploadImportProductFile", data)
        .then((res) => {
          this.resetList();
          this.resetCountItems();
          this.resetCountImportedItems();
          this.activeStep(true);
          this.productFileId = res;
          this.spinShow = false;
        })
        .catch(() => {
          this.spinShow = false;
        });
    }
    return false;
  }
}
